import { get } from "lodash";
import { TableColumn } from "PFApp/components/table/table_types";
import ProgressBar from "PFComponents/progress_bar/progress_bar";
import Tooltip from "PFComponents/tooltip/tooltip";
import { Typography } from "PFComponents/typography";
import { SkillsFramework } from "PFTypes";
import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { humanize, titleize } from "underscore.string";

import css from "./skills_frameworks_table.module.scss";

const LOW_COVERAGE_COLOR = "#9B5A01";
const HIGH_COVERAGE_COLOR = "var(--Palette-status-success)";
const EMPTY_SIGN = "-";

export const useSkillsFrameworksCellRenderer = () =>
  useCallback((skillsFramework: SkillsFramework, column: TableColumn) => {
    const values = get(skillsFramework, column.attribute || [], []);
    if (column.name === "name") {
      return (
        <Link to={`/admin/skills_frameworks/${skillsFramework.id}/edit`}>
          <Typography variant="bodyBold" className={css.link} noMargin>
            {values}
          </Typography>
        </Link>
      );
    } else if (column.name === "description") {
      return (
        <Tooltip
          content={
            <Typography variant="bodyRegular" className={css.tooltipDescription} noMargin>
              {values}
            </Typography>
          }
          interactive
          disabled={!values}
        >
          <div className={css.description}>{values || EMPTY_SIGN}</div>
        </Tooltip>
      );
    } else if (/^customField/.test(column.name)) {
      return <div>{titleize(humanize(values?.displayAs || "") || EMPTY_SIGN)}</div>;
    } else if (column.name === "insights") {
      const value = values / 100;
      return (
        <div style={{ width: 60 }}>
          {Math.round(value * 100)}%
          <ProgressBar
            values={[{ value, color: value > 0.5 ? HIGH_COVERAGE_COLOR : LOW_COVERAGE_COLOR }]}
            totalValue={1}
          />
        </div>
      );
    } else if (["skillsCount", "profilesCount"].includes(column.name)) {
      return String(values);
    }
  }, []);
